const StoreTagOptions: readonly string[] = [
  "South Indian",
  "Chettinad",
  "Biryani",
  "BBQ",
  "Grill",
  "Arabian",
  "Tandoori",
  "Chinese",
  "North Indian",
  "Fast Food",
  "Burger",
  "Cafe",
  "Bakery",
  "Beverages",
  "Juices",
  "Ice Cream",
  "Desserts",
  "Sweets",
  "Parotta",  
  "Meals",
  "Fried Chicken",
  "Italian",
  "Korean",
  "Pizza",
] as const;

const foodAndBeverageTypeOptions: readonly { value: string; label: string }[] =
  [
    { value: "pure-veg", label: "Pure Veg" }, 
    { value: "veg", label: "Veg" },
    { value: "non-veg", label: "Non–Veg" },
    { value: "egg", label: "Egg" },
    { value: "veg-and-non-veg", label: "Veg and Non-Veg" },   
  ] as const;

export { StoreTagOptions, foodAndBeverageTypeOptions };
